// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const HeroNavigationWithContainerTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      darkOverlay: 'absolute inset-0 z-[1] bg-[rgba(0,0,0,0.60)]',
      contentWrapper:
        'relative w-full flex flex-col md:min-h-[70vh] md:py-[80px] md:!text-white items-center',
      contentContainer:
        'relative z-[2] flex flex-col gap-xxs py-s sm:px-m mr-auto w-full md:w-2/3 md:order-0 order-1 md:mr-0 md:justify-start md:min-h-[70vh] md:[&>div]:!text-white ' +
        'md:[&_a]:!text-white md:[&_a:link]:!text-white md:[&_a:visited]:!text-white md:[&_a:hover]:!text-white',
      headline:
        'font-sans text-sm-m pt-s md:text-xl md:leading-[64px] font-medium md:max-w-[42rem]',
      heroSubHeadlineText:
        'text-body md:text-white !font-serif mb-l text-dark-gray md:text-white md:text-large-body col-span-12 md:max-w-[42rem] [&_*]:max-w-full [&_a]:underline [&_a]:text-black md:[&_a]:!text-white' +
        'md:[&_a:link]:!text-white md:[&_a:visited]:!text-white md:[&_a:hover]:!text-white',
      subHeadlineText:
        'inline-block self-start border-b-4 border-b-primary pb-[10px] font-sans text-m font-medium md:text-white',
      bodyClass:
        'body-copy text-dark-gray col-span-12 [&_*]:max-w-full [&_a]:!text-black [&_a]:underline md:text-white md:text-large-body md:[&_a]:!no-underline md:[&_a:hover]:!underline',
      componentContainerWrapper:
        'md:order-0 order-3 flex w-full !grow items-center lg:w-1/3 justify-start md:mb-m md:mt-l md:justify-end',
      componentContainer:
        'componentContainer z-[2] w-full bg-white flex flex-col py-s md:mx-m gap-s [&_div]:!text-black [&_h2]:items-top [&_h2]:font-sans [&_h2]:text-m [&_h2]:font-medium',
    },
  },
};
